import EnhancedHierarchyKPIDetails from './EnhancedHierarchyKPIDetails'
export default EnhancedHierarchyKPIDetails
